import { useEffect, useRef, useState } from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useNavigate
} from "react-router-dom";
import MTable from '../../Components/MTable/MTable';
import { getAllStockReady } from '../../Service/StockService';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay';
import moment from 'moment';
import 'moment/locale/id';

const data = [
    {
        "id": 46,
        "ordernumber": "#221000236",
        "status": 'Reject',
        "customer": "Arief Nurakhman",
        "created": "2022-07-12"
    },

]

const Stock = () => {
    moment.locale('id');
    const navigate = useNavigate();
    const tableStock = useRef();
    const [state, setState] = useState({ processing : false });
    const columns = [
        { id: 1, title: 'Item Code', field: 'ItemCode', sortable: true },
        { id: 2, title: 'Item Name', field: 'ItemName', sortable: true },
        { id: 3, title: 'Stock Ready', field: 'OnHand_ready', sortable: true },
        { id: 4, title: 'Stock Display', field: 'OnHand_display', sortable: true },
        { id: 5, title: 'Stock Indent', field: 'OnHand_indent', sortable: true },
    ];

    const propsTable = { columns, getData: getAllStockReady, showIndex: true, order: 'ItemName', direction: 'asc', hideFilter:'true'};
    
    return (
        <div className="content-wrapper">
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h2 className="title-breadcrum">Stock Ready List</h2>
                        </div>
                    </div>
                </div>
            </div>
            <section className="content">
                <div className="container-fluid">
                    <div className="card shadow mb-4">
                        <div className="card-body">
                            <Overlay display={state.processing} />
                            <div className='table-responsive'>
                                <MTable {...propsTable} ref={tableStock} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );

};

export default Stock;